<template>
    <div class="w-ticket flex flex-col items-center justify-center">
        <div
            id="barcode-container"
            class="bg-white text-black flex flex-col items-center py-3 px-3 rounded"
        >
            <slot name="top"></slot>
            <barcode-viewer class="w-full" :input="barcode" />
            <slot name="bottom"></slot>
        </div>

        <app-button class="mt-3" color="#02913f" relief @click="generateImage">
            <span class="py-1"> Descargar Imagen </span>
        </app-button>
    </div>
</template>

<script>
import { downloadElementImage } from "@/common/lib/images";

import BarcodeViewer from "@/components/utils/BarcodeViewer.vue";

export default {
    name: "BarcodeGenerator",
    components: { BarcodeViewer },
    props: {
        barcode: {
            default: () => "",
            required: true,
            type: String
        },
        label: {
            default: () => "",
            required: false,
            type: String
        }
    },
    methods: {
        async generateImage() {
            try {
                await downloadElementImage(
                    document.getElementById("barcode-container"),
                    `barcode_${this.barcode}`
                );
            } catch (error) {
                this.$swal.fire({
                    icon: "error",
                    title: "No pudimos generar la imagen",
                    text: error?.message || "Intenta de nuevo en unos segundos."
                });
            }
        }
    }
};
</script>
